import { render } from "./PostProgram.vue?vue&type=template&id=47cda8e0"
import script from "./PostProgram.vue?vue&type=script&lang=js"
export * from "./PostProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__